import { render } from "./AppModalAnsvar.vue?vue&type=template&id=cbca2236&scoped=true"
import script from "./AppModalAnsvar.vue?vue&type=script&lang=js"
export * from "./AppModalAnsvar.vue?vue&type=script&lang=js"

import "./AppModalAnsvar.vue?vue&type=style&index=0&id=cbca2236&lang=scss&scoped=true"
import "./AppModalAnsvar.vue?vue&type=style&index=1&id=cbca2236&lang=scss"

import exportComponent from "/Users/patriksvensson/Documents/Projects/KK/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbca2236"]])

export default __exports__